import { render, staticRenderFns } from "./vxeGridCell.vue?vue&type=template&id=32920168&scoped=true&"
import script from "./vxeGridCell.vue?vue&type=script&lang=ts&"
export * from "./vxeGridCell.vue?vue&type=script&lang=ts&"
import style0 from "./vxeGridCell.vue?vue&type=style&index=0&id=32920168&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32920168",
  null
  
)

export default component.exports